'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const parseISOTimeIntervalToMilliseconds = (unorderedInterval) => {
  const start = parsers.isoTimePartToDate(unorderedInterval.start);
  const endCandidate = parsers.isoTimePartToDate(unorderedInterval.end);
  const isPositiveDuration = dateFns.isAfter(endCandidate, start);
  const end = isPositiveDuration ? endCandidate : dateFns.addDays(endCandidate, 1);
  return dateFns.differenceInMilliseconds(end, start);
};

module.exports = parseISOTimeIntervalToMilliseconds;
//# sourceMappingURL=parseISOTimeIntervalToMilliseconds.cjs.map
